<template>
  <div class="person-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">Financeiro &raquo; {{ termPlural }}</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto" v-if="canAdd">
                <router-link tag="a" class="btn btn-primary btn-sm" :to="'/financeiro/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row class="mb-2">
            <b-col>
              <label class="cj-label">Período</label>
              <date-range-picker
                class="w-100"
                ref="picker"
                :localeData="dateRangePickerPtBrLocale"
                :timePicker="false"
                :timePicker24Hour="false"
                :showDropdowns="true"
                :ranges="false"
                :showWeekNumbers="false"
                :opens="'right'"
                v-model="transactionFilterForm.dateTime">
                <div slot="input" slot-scope="picker" class="">
                  {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
                </div>
              </date-range-picker>
            </b-col>
            <b-col>
              <label class="cj-label">Filtrar período por</label>
              <multiselect v-model="transactionFilterForm.periodFilter" :options="periodFilterOptions" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false"></multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Paciente</label>
              <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="transactionFilterForm.patient" :options="people" track-by="name" label="name" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="transactionFilterForm.patient != null" @mousedown.prevent.stop="transactionFilterForm.patient = null"></div>
                </template>
                <template slot="noOptions">
                  <div>
                    Digite para pesquisar seus pacientes...
                  </div>
                </template>
                <template slot="noResult" v-if="!isLoadingPeople">
                  <div>
                    Nenhum paciente encontrado...
                  </div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Profissional</label>
              <multiselect v-model="transactionFilterForm.professional" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="transactionFilterForm.professional != null" @mousedown.prevent.stop="transactionFilterForm.professional = null"></div>
                </template>
              </multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label class="cj-label">Descrição</label>
              <b-form-input type="text" v-model="transactionFilterForm.description"></b-form-input>
            </b-col>
            <b-col>
              <label class="cj-label">Categoria</label>
              <multiselect v-model="transactionFilterForm.category" :options="categories" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="transactionFilterForm.category != null" @mousedown.prevent.stop="transactionFilterForm.category = null"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Status</label>
              <multiselect v-model="transactionFilterForm.discharged" :options="dischargedOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="transactionFilterForm.discharged != null" @mousedown.prevent.stop="transactionFilterForm.discharged = null"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getTransactions()"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <p class="title">Lista de {{ termPlural }}</p>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
                      <th>Paciente</th>
                      <th>Descrição</th>
                      <th>Categoria</th>
                      <th>Valor</th>
                      <th>Data de lançamento</th>
                      <th>Vencimento</th>
                      <th>Status</th>
                      <th>Baixa</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="line-add" v-if="canAdd">
                      <td colspan="9" class="text-center">
                        <router-link tag="a" class="btn btn-block btn-sm btn-add-new" :to="'/financeiro/'+url+'/'+newTerm"><i class="far fa-plus-circle"></i> Adicionar nov{{ letter}} {{termSingular}}</router-link>
                      </td>
                    </tr>
                    <tr v-for="transaction in transactions" :key="transaction.id">
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">{{ (transaction.patient != null)?transaction.patient.name:'-' }}</router-link>
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">{{ transaction.description }}</router-link>
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">{{ transaction.category != null ? transaction.category.name : '' }}</router-link>
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">R$ {{ formatPrice(transaction.value) }}</router-link>
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">{{ moment(transaction.registration_date).format('DD/MM/YYYY') }}</router-link>
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">{{ transaction.charge_date != null ? moment(transaction.charge_date).format('DD/MM/YYYY') : '' }}</router-link>
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">{{ transaction.deleted_at != null ? 'Excluído' : (!transaction.discharged?'Não ':'') }} {{ transaction.deleted_at != null ? '' : dischargedTerm.replace(/^./, dischargedTerm[0].toUpperCase()) }}</router-link>
                      <router-link tag="td" :to="'/financeiro/'+url+'/'+transaction.id" :class="{'disabled-link': transaction.deleted_at != null}">{{ transaction.discharge_date != null ? moment(transaction.discharge_date).format('DD/MM/YYYY') : '' }}</router-link>
                      <td>
                        <b-button v-if="canEdit && transaction.deleted_at == null" variant="primary" size="sm" block @click="showChangeStatusModal(transaction)"><i class="fas fa-dollar-sign"></i></b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="transactions.length == 0" class="text-center sub-title">Você ainda não possui nenhum{{ (letter != 'o')?letter:'' }} {{ termSingular }} cadastrad{{ letter }}.</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-modal id="change-status-modal" class="change-status-modal" :modalClass="'change-status-modal'" @hidden="resetChangeStatusModal">
      <template slot="modal-header" v-if="termSingular.length > 0">
        Detalhes da {{ termSingular.replace(/^./, termSingular[0].toUpperCase()) }}
      </template>
      <template slot="default">
        <validation-observer ref="changeStatusForm" v-slot="{ invalid }">
          <div v-if="changeStatusForm.transaction != null">
            <b-row>
              <b-col>
                <label class="cj-label">Paciente</label>
                <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="changeStatusForm.transaction.patient" :options="people" track-by="name" label="name" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" :disabled="true" placeholder="Selecione">
                </multiselect>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label class="cj-label">Descrição</label>
                <validation-provider name="descrição" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="changeStatusForm.transaction.description" :disabled="true" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                  <label class="cj-label">Valor</label>
                  <money v-model="changeStatusForm.transaction.value" class="form-control mb-2" :disabled="true" :class="{ 'error': errors.length > 0 }"></money>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Vencimento</label>
                <validation-provider name="vencimento" :rules="{ required: true }" v-slot="{ errors }">
                  <date-picker name="date" v-model="changeStatusForm.transaction.charge_date" v-mask="'##/##/####'" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <div class="pretty positive p-default">
                  <input type="checkbox" v-model="changeStatusForm.transaction.discharged" />
                  <div class="state p-success">
                    <label class="cj-label">{{ ($route.meta.type == 'INCOME')?'Recebido':'Pago' }}</label>
                  </div>
                </div>
                <validation-provider name="data da quitação" :rules="{ required: changeStatusForm.transaction.discharged }" v-slot="{ errors }">
                  <date-picker name="date" v-model="changeStatusForm.transaction.discharge_date" v-mask="'##/##/####'" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" :disabled="!changeStatusForm.transaction.discharged" autocomplete="off"></date-picker>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('change-status-modal')">Fechar</b-button>
        <b-button v-if="canEdit" size="sm" variant="success" @click="saveTransaction">Salvar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: '',
        termPlural: '',
        url: '',
        letter: '',
        newTerm: '',
        dischargedTerm: '',
        module: '',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canPerformAction: true,

        transactionFilterForm: {
          dateTime: { startDate: this.moment().startOf('month'), endDate: this.moment().endOf('month') },
          periodFilter: { value: 'charge_date', name: 'Vencimento' },
          patient: null,
          professional: null,
          description: '',
          category: null,
          discharged: null,
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        },

        categories: [],
        professionals: [],
        periodFilterOptions: [
          { value: 'discharge_date', name: 'Baixa' },
          { value: 'charge_date', name: 'Vencimento' },
          { value: 'registration_date', name: 'Data de lançamento' },
        ],
        dischargedOptions: [],

        people: [],
        isLoadingPeople: false,

        transactions: [],

        changeStatusForm: {
          transaction: null,
          discharged: false,
          discharge_date: ''
        },

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },
      }
    },
    async mounted () {
      if(this.$route.meta.type == 'INCOME') {
        this.termSingular = 'receita';
        this.termPlural = 'contas a receber';
        this.url = 'contas-a-receber';
        this.letter = 'a';
        this.newTerm = 'cadastrar-receita';
        this.dischargedTerm = 'recebido';
        this.module = 'incomes';
      } else if(this.$route.meta.type == 'EXPENSE') {
        this.termSingular = 'despesa';
        this.termPlural = 'contas a pagar';
        this.url = 'contas-a-pagar';
        this.letter = 'a';
        this.newTerm = 'cadastrar-despesa';
        this.dischargedTerm = 'pago';
        this.module = 'expenses';
      }

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false || !this.helpers.planHasPermission('financial')) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' });
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);

      if(this.$route.query.patient_id) {
        this.transactionFilterForm.patient = { value: this.$route.query.patient_id, name: this.$route.query.patient_name };
      }
      if(this.$route.query.period_filter) {
        this.transactionFilterForm.periodFilter = this.periodFilterOptions.find(g => g.value == this.$route.query.period_filter);
      }
      if(this.$route.query.min_date) {
        this.transactionFilterForm.dateTime = { startDate: this.moment(this.$route.query.min_date), endDate: this.moment(this.$route.query.max_date) };
      }

      // dateTime: { startDate: this.moment().startOf('month'), endDate: this.moment().endOf('month') },
      // periodFilter: { value: 'charge_date', name: 'Vencimento' },
      // patient: null,

      await this.api.getPeople({type: 'PROFESSIONAL'}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.professionals = [];
        res.data.data.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Professional', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os profissionais da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Professional', err.response);
      });

      await this.api.getCategories({ type: this.module }).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.categories = [];
        res.data.forEach(category => {
          this.categories.push({value: category.id, name: category.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Categories', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as categorias! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Categories', err.response);
      });

      this.dischargedOptions = [
        // { value: null, name: 'Indiferente' },
        { value: 1, name: this.dischargedTerm.replace(/^./, this.dischargedTerm[0].toUpperCase()) },
        { value: 0, name: 'Não '+this.dischargedTerm.replace(/^./, this.dischargedTerm[0].toUpperCase()) },
        { value: 'deleted', name: 'Excluído' }
      ];

      await this.getTransactions();
    },
    watch: {
      searchBy: function(val) {
        val = new RegExp(val.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), 'i');
        this.peopleFiltred = this.people.filter(person => {
          return ((person.name != null && person.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "").search(val) > -1) || (person.email != null && person.email.normalize('NFD').replace(/[\u0300-\u036f]/g, "").search(val) > -1) || (person.telephone != null && person.telephone.normalize('NFD').replace(/[\u0300-\u036f]/g, "").search(val) > -1) || (person.cellphone != null && person.cellphone.normalize('NFD').replace(/[\u0300-\u036f]/g, "").search(val) > -1));
        });
      },
      'changeStatusForm.transaction.discharged': function(val) {
        if(!val && this.changeStatusForm.transaction != null)
          this.changeStatusForm.transaction.discharge_date = '';
      }
    },
    methods: {
      getTransactions() {
        let transactionFilterData = {
          type: this.$route.meta.type,
          start_date: this.moment(this.transactionFilterForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.transactionFilterForm.dateTime.endDate).format('YYYY-MM-DD'),
          period_filter: this.transactionFilterForm.periodFilter.value,
          patient: (this.transactionFilterForm.patient != null)?this.transactionFilterForm.patient.value:null,
          professional: (this.transactionFilterForm.professional != null)?this.transactionFilterForm.professional.value:null,
          description: this.transactionFilterForm.description,
          category: (this.transactionFilterForm.category != null)?this.transactionFilterForm.category.value:null,
          discharged: (this.transactionFilterForm.discharged != null)?this.transactionFilterForm.discharged.value:null
        };

        this.api.getTransactions(transactionFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.transactions = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Transactions', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar '+this.letter+'s '+this.termSingular+' da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Transactions', err.response);
        });
      },

      limitPeople(qty) {
        return 'e '+qty+' outros pacientes';
      },

      findPeople(query) {
        this.people = [];
        if(query.length >= 3 && !this.isLoadingPeople) {
          this.isLoadingPeople = true;
          this.api.getPeople({ type: 'PATIENT', name: query }).then(res => {
            if(this.leavingPage) {
              return;
            }
            this.isLoadingPeople = false;

            res.data.data.forEach(patient => {
              this.people.push({
                value: patient.id,
                name: patient.name
              });
            });
          }).catch(err => {
            if(this.leavingPage) {
              return;
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Patients', err.response);
          });
        }
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      resetChangeStatusModal() {
        this.changeStatusForm = {
          transaction: null,
        }
      },

      showChangeStatusModal(transaction) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;
        this.changeStatusForm.transaction = Object.assign({}, transaction);

        this.changeStatusForm.transaction.charge_date = this.moment(transaction.charge_date).format('DD/MM/YYYY');
        this.changeStatusForm.transaction.discharge_date = (this.moment(transaction.discharge_date).isValid())?this.moment(transaction.discharge_date).format('DD/MM/YYYY'):'';

        this.$bvModal.show('change-status-modal');
        this.canPerformAction = true;
      },

      async saveTransaction() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        const isValid = await this.$refs.changeStatusForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let transactionData = {
          charge_date: this.changeStatusForm.transaction.charge_date,
          discharged: this.changeStatusForm.transaction.discharged,
          discharge_date: (this.changeStatusForm.transaction.discharged)?this.changeStatusForm.transaction.discharge_date:''
        };

        this.api.dischargeTransaction(this.changeStatusForm.transaction.id, transactionData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          if (res.status == 200) {
            this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi atualizada com sucesso!', 'success');

            this.getTransactions();
          } else {
            this.$swal('Ops...', 'Ocorreu um erro ao atualizar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Update Transaction', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos atualizar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Update Transaction', err.response);
        });

        this.$bvModal.hide('change-status-modal');
        this.canPerformAction = true;
      },
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .person-list {
    padding: 20px 0;

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }
        }
      }
    }
  }

  .disabled-link{
    pointer-events: none;
  }
</style>
